'use strict';/* global define:false, console:false, Raven:false */define('modules/core/modules/app/services/exception-handler/index',['require'],function(require){'use strict';/**
   * Exception handler to be called
   * when an exception rises in angular scope
   *
   * @tested
   */// @ngInject
handler.$inject = ["airbrake", "$log", "ClampsVersion", "Environment", "appState", "_"];
function handler(airbrake,$log,ClampsVersion,Environment,appState,_){return function(exception,cause){if(!appState.isRefreshing()){$log.error(exception);var airbrakeClient=airbrake.get();if(airbrakeClient){//filter sensitive data
var filteredCause=_.cloneDeepWith(cause,function(value,key){if(/password/i.test(key)){return'<FILTERED>';}});// To replace as soon as the fe logger is done by Lorenz
// airbrakeClient.notify( {
//   error  : exception,
//   params : {
//     angularCause : filteredCause,
//     cVersion     : ClampsVersion.get()
//   }
// } );
}}};}return handler;});
